export default "__VITE_ASSET__BVCj0Quq__"